const GTM_ID = 'GTM-PV68VJLJ';

/**
 * Only the live site reports. Localhost, the test environment and a colleague's
 * machine all stay out of Bromma's container.
 *
 * NODE_ENV cannot be used for this: deploy.sh runs `yarn build` on every
 * environment, so a test build is also NODE_ENV=production. Checking the
 * hostname needs no configuration on the server either, so there is no way to
 * deploy and silently end up with no tracking at all.
 */
const TRACKED_HOSTS = ['backyard.bromma.com'];

/**
 * @param string hostname
 */
export function shouldTrack(hostname) {
	return TRACKED_HOSTS.indexOf(hostname) !== -1;
}

/**
 * Load Google Tag Manager.
 *
 * This is Bromma's standard GTM snippet, kept here rather than in index.html so
 * it can be limited to the live site. The container id is not a secret, it is
 * visible in the page source of every site that uses GTM.
 *
 * The <noscript> iframe from the official snippet is deliberately left out:
 * this app is entirely client rendered, so a visitor without JavaScript never
 * gets further than the "You need to enable JavaScript" message.
 */
export default function register() {
	if (!shouldTrack(window.location.hostname)) return;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'gtm.start': new Date().getTime(),
		event: 'gtm.js',
	});

	const script = document.createElement('script');
	script.async = true;
	script.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;

	document.head.appendChild(script);
}



// WEBPACK FOOTER //
// ./src/registerGTM.js